import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { formatApiError } from "../lib/api";
import AuthShell, { googleLogin } from "../components/AuthShell";
import { Loader2 } from "lucide-react";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await register(email, password, name);
      navigate("/dashboard");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell
      title="Begin your transformation"
      subtitle="Create your free account and start today."
      footer={<>Already a member? <Link to="/login" className="text-[#4da6ff] hover:underline">Sign in</Link></>}
    >
      <form onSubmit={submit} className="space-y-4" data-testid="register-form">
        {error && <div className="text-sm text-red-400 bg-red-500/10 border border-red-500/20 rounded-lg px-4 py-2" data-testid="register-error">{error}</div>}
        <input data-testid="register-name" required placeholder="Your name" value={name} onChange={(e) => setName(e.target.value)}
          className="w-full field px-4 py-3" />
        <input data-testid="register-email" type="email" required placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)}
          className="w-full field px-4 py-3" />
        <input data-testid="register-password" type="password" required placeholder="Password (min 6 chars)" value={password} onChange={(e) => setPassword(e.target.value)}
          className="w-full field px-4 py-3" />
        <button type="submit" disabled={loading} data-testid="register-submit"
          className="w-full bg-[#4da6ff] hover:bg-[#7ab8ff] text-white font-medium rounded-full py-3 transition-colors flex items-center justify-center gap-2 disabled:opacity-60">
          {loading && <Loader2 className="w-4 h-4 animate-spin" />} Create account
        </button>
      </form>
      <div className="flex items-center gap-3 my-6">
        <div className="flex-1 h-px bg-zinc-800" /><span className="text-xs text-zinc-600">or</span><div className="flex-1 h-px bg-zinc-800" />
      </div>
      <button onClick={googleLogin} data-testid="register-google"
        className="w-full bg-white text-black font-medium rounded-full py-3 transition-transform hover:scale-[1.02] flex items-center justify-center gap-2">
        <img src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg" alt="" className="w-5 h-5" /> Continue with Google
      </button>
    </AuthShell>
  );
}
